import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import {
  MemberPointList,
  PointConfig,
  MemberList,
  MemberDetail,
  MemberPoinInfo,
  EarnPointHistory,
  BurnPointHistory,
  AllMemberEarnPointHistory,
  AllBurnPointHistory,
} from './types'

export const selectActionEvent = (state: RootState): Event => state.memberPointReducer.actionEvent

export const selectMemberPointList = (state: RootState): MemberPointList => state.memberPointReducer.pointList

export const selectPointConfigDatail = (state: RootState): PointConfig =>
  state.memberPointReducer.pointConfigData

export const selectDelteConfigEvent = (state: RootState): Event => state.memberPointReducer.deleteEvent

export const selectMemberList = (state: RootState): MemberList => state.memberPointReducer.memberList

export const selectMemberDatail = (state: RootState): MemberDetail => state.memberPointReducer.memberDetail

export const selectMemberPointInfo = (state: RootState): MemberPoinInfo =>
  state.memberPointReducer.memberPointInfo

export const selectUpdateActionEvent = (state: RootState): Event => state.memberPointReducer.updateActionEvent

export const selectEarnPointHistory = (state: RootState): EarnPointHistory =>
  state.memberPointReducer.earnPointHistory

export const selectBurnPointHistory = (state: RootState): BurnPointHistory =>
  state.memberPointReducer.burnPointHistory

export const selectAllMemberEarnPointHistory = (state: RootState): AllMemberEarnPointHistory =>
  state.memberPointReducer.allMemberEarnPointHistory

export const selectAllMemberBurnPointHistory = (state: RootState): AllBurnPointHistory =>
  state.memberPointReducer.allMemberBurnPointHistory
